import React from 'react';
import { PlaneIcon, HotelIcon, MapIcon, CarIcon, UmbrellaIcon, HeadphonesIcon } from 'lucide-react';
const services = [{
  icon: <PlaneIcon size={36} className="text-red-600" data-id="element-224" />,
  title: 'Flight Booking',
  description: 'Get the best deals on flights to destinations worldwide'
}, {
  icon: <HotelIcon size={36} className="text-red-600" data-id="element-225" />,
  title: 'Hotel Reservations',
  description: 'Book accommodations that fit your style and budget'
}, {
  icon: <MapIcon size={36} className="text-red-600" data-id="element-226" />,
  title: 'Tour Packages',
  description: 'All-inclusive packages with guided experiences'
}, {
  icon: <CarIcon size={36} className="text-red-600" data-id="element-227" />,
  title: 'Transportation',
  description: 'Convenient airport transfers and car rentals'
}, {
  icon: <UmbrellaIcon size={36} className="text-red-600" data-id="element-228" />,
  title: 'Travel Insurance',
  description: 'Comprehensive coverage for worry-free travel'
}, {
  icon: <HeadphonesIcon size={36} className="text-red-600" data-id="element-229" />,
  title: '24/7 Support',
  description: 'Assistance whenever and wherever you need it'
}];
const Services = () => {
  return <section className="py-16" data-id="element-230">
      <div className="container mx-auto px-4" data-id="element-231">
        <div className="text-center mb-12" data-id="element-232">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-233">
            Our Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-234">
            Forsa Co. offers comprehensive travel services to make your journey
            seamless from start to finish
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-235">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-236">
              <div className="mb-4" data-id="element-237">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-238">{service.title}</h3>
              <p className="text-gray-600" data-id="element-239">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Services;